import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { useWorkspaceStore } from '@/store/workspace'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/Register.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Dashboard.vue')
      },
      {
        path: 'assets',
        name: 'Assets',
        component: () => import('@/views/assets/AssetList.vue')
      },
      {
        path: 'assets/create',
        name: 'AssetCreate',
        component: () => import('@/views/assets/AssetForm.vue')
      },
      {
        path: 'assets/:id/edit',
        name: 'AssetEdit',
        component: () => import('@/views/assets/AssetForm.vue')
      },
      {
        path: 'snapshots',
        name: 'Snapshots',
        component: () => import('@/views/snapshots/SnapshotList.vue')
      },
      {
        path: 'snapshot-analytics',
        name: 'SnapshotAnalytics',
        component: () => import('@/views/SnapshotAnalytics.vue'),
        meta: { title: '快照趋势分析' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/settings/Settings.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/common/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()
  const workspaceStore = useWorkspaceStore()

  // 检查是否需要认证
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
    return
  }

  // 如果已登录但访问登录页，重定向到首页
  if ((to.path === '/login' || to.path === '/register') && authStore.isAuthenticated) {
    next('/dashboard')
    return
  }

  // 如果需要认证，确保工作空间已加载
  if (to.meta.requiresAuth && workspaceStore.workspaces.length === 0 && authStore.isAuthenticated) {
    try {
      await workspaceStore.fetchWorkspaces()
      // fetchWorkspaces 内部已经处理了工作空间的选择逻辑
      // 这里不需要再次设置，避免覆盖已有的选择
    } catch (error: any) {
      // 如果是 401 错误，说明认证已失效，跳转到登录页
      if (error?.response?.status === 401) {
        next('/login')
        return
      }
      console.error('Failed to load workspaces:', error)
    }
  }

  next()
})

export default router
